import NoData from './NoData.vue'
export default NoData
